import { actionTypes } from 'memberPortalModules/MemberProfile/constants';
import { fromJS } from 'immutable';
import { initReqStateImt } from 'common/constants/initialState';
import { RESOLVE_PERSON_MISSING_BILLING_INFO } from '../billingActions/constants';

import { AlertCondition } from 'common/interfaces/alerts';

export const profileReducer = (state = initReqStateImt, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROFILE_INFO:
    case actionTypes.UPDATE_PROFILE_INFO:
      return state.set('result', fromJS(action.payload));
    case actionTypes.FETCH_PROFILE_INFO_LOADING:
      return state.set('isLoading', action.payload);
    case actionTypes.RESET_PROFILE_INFO:
      return initReqStateImt;

    case RESOLVE_PERSON_MISSING_BILLING_INFO:
      return state.update('alerts', alerts =>
        alerts?.filter(alertItem => alertItem.get('condition') !== action.payload),
      );

    case actionTypes.FETCH_PERSON_ALERTS:
      return state.set('alerts', fromJS(action.payload));
    case actionTypes.FETCH_PERSON_ALERTS_LOADING:
      return state.set('alertsLoading', action.payload);

    case actionTypes.RESOLVE_PAST_DUE_ALERT:
      return state.update('alerts', alerts =>
        alerts?.filter(alertItem => alertItem.get('condition') !== action.payload),
      );

    case actionTypes.FETCH_SENDER_AVAILABILITY_LOADING: {
      const { isLoading, type } = action.payload;

      return state.setIn(['sendAvailability', type, 'isLoading'], isLoading);
    }
    case actionTypes.FETCH_SENDER_AVAILABILITY: {
      const { data, type } = action.payload;
      return state.setIn(['sendAvailability', type, 'data'], fromJS(data));
    }

    case actionTypes.FETCH_BALANCE_HISTORY_LOADING:
      return state.set('balanceHistoryLoading', action.payload);

    case actionTypes.FETCH_BALANCE_HISTORY:
      return state.set('balanceHistory', action.payload.data);

    case actionTypes.FETCH_REWARDS_HISTORY_LOADING:
      return state.set('rewardsHistoryLoading', action.payload);

    case actionTypes.FETCH_REWARDS_HISTORY:
      return state.set('rewardsHistory', action.payload);

    case actionTypes.UPDATE_PERSON_PHOTO:
      const alerts = state.get('alerts');
      const newAlerts = alerts?.filter(alert => alert !== AlertCondition.MissingPhoto);

      return state
        .setIn(['result', 'image'], action.payload ? fromJS(action.payload) : null)
        .set('alerts', newAlerts);
    case actionTypes.UPDATE_PERSON_PHOTO_LOADING:
      return state.setIn(['result', 'imageLoading'], action.payload);

    default:
      return state;
  }
};
